<template>
  <div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" buttonText="Lihat rincian" :url="`/invoice/detail/${entry.id}`"
          linkType="internal" type="secondary" size="small" />
        <span class="block" v-else-if="column.field === 'created_at'">
          {{ entry[column.field] | formatDate }}
        </span>
        <span class="block break-all" v-else-if="column.field === 'id'">
          {{ entry[column.field] }}
        </span>
        <span v-else>{{ entry[column.field] }}</span>
      </template>
    </TableComponent>
  </div>
</template>
<script>
export default {
  components: {
    // TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    // Search: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Search'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    // Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data: () => ({
    columns: [
      // { label: 'ID', field: 'id' },
      // { label: 'Tanggal', field: 'date' },
      { label: 'Nama Merchant', field: 'merchant_name' },
      { label: 'Total Order', field: 'qty' },
      { label: 'Total Price', field: 'price' },
      { label: 'Action', field: 'action' }
    ],
    data: [
      {
        id: 1,
        // date: '2025-01-01',
        merchant_name: 'PT.Merchant',
        qty: 5,
        price: '14.000'
      },
      {
        id: 2,
        // date: '2025-01-01',
        merchant_name: 'PT.Merchant2',
        qty: 5,
        price: '10.000'
      },
      {
        id: 3,
        // date: '2025-01-01',
        merchant_name: 'PT.Merchant3',
        qty: 5,
        price: '20.000'
      },
    ]
  }),
  computed: {
    filteredData() {
      let temp = this.data || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
  },
}

</script>
<style lang="">

</style>